import httpService from './httpService';

export const unacceptedAgreements = (): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Users/agreements/unaccepted`);
  return httpService.get(endpoint);
};

export const acceptAgreements = (agreementId: string): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Users/agreements/${agreementId}/accept`);
  return httpService.post(endpoint);
};

export const getAgreementFile = (id: string | number): Promise<any> => {
  return httpService.get(httpService.getEndpointURL(`/Users/agreements/${id}/download`), { responseType: 'arraybuffer' });
};

export const getAgreement = (id: string): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Agreements/${id}`);
  return httpService.get(endpoint);
};

// TODO: This service is not used - What should we do with it?
export const downloadAgreements = (agreementId: number): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Documents/Download/${agreementId}`);
  return httpService.get(endpoint).then((response) => {
    const data = response.data;
    return new Uint8Array(data);
  });
};
